function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesMortgageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    style: {
      fill: "#2e2447"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.74,161.8V94H102.83V383a47,47,0,0,0,47,47H336.74",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.69,
    y1: 369.26,
    x2: 336.69,
    y2: 289.85,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.53,430h108.8a30.37,30.37,0,0,0,30.37-30.37h0a30.37,30.37,0,0,0-30.37-30.37h-201",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.29,430a30.36,30.36,0,0,0,30.38-30.36h0a30.37,30.37,0,0,0-30.37-30.37h0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.54,
    y1: 231.75,
    x2: 151.13,
    y2: 231.75,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.88,
    y1: 183.38,
    x2: 151.13,
    y2: 183.38,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.96,
    y1: 280.14,
    x2: 151.13,
    y2: 280.14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.95 300.11 260.03 301.16 261.08 278.24 377.3 162.02 399.17 183.89 282.95 300.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesMortgageIcon);
export default __webpack_public_path__ + "static/media/notes-mortgage-icon.4ee14582246bc3154628eadaa6c5386e.svg";
export { ForwardRef as ReactComponent };